import * as angular from "angular";
import {IController} from "angular";

export class adminUserViewCtrl implements IController {
  tabs: any;

  private currentNavItem: any;

  /* @ngInject */
  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.url;
  }


}

angular
  .module('bringoz.admin.admins')
  .component('adminUserView', {
    bindings: {
      tabs: '<'
    },
    template: require('./admin-user-view.html').default,
    controller: adminUserViewCtrl
  });
